import {findContainer, getDataAttributes, mergeDeepObject} from "./_util";
import Swiper, {Autoplay, Navigation, Pagination, EffectFade, EffectCreative, Lazy, Parallax, Thumbs, Manipulation, Grid} from 'swiper';
Swiper.use([Navigation, Pagination, Parallax, EffectFade, EffectCreative, Lazy, Autoplay, Grid, Thumbs, Manipulation]);

window.VGCarousel = {
	isDebug: false,
	breakpoints: {
		xs: 0,
		sm: 640,
		md: 767,
		lg: 991,
		xl: 1199,
		xxl: 1399,
		xxxl: 1599
	},

	init: function (carousel, arg = {}) {
		if (!carousel) {
			VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
			return false;
		}

		let params = {}, option = {}, dataParams = {}, _this = this;

		if (typeof carousel === 'string') {
			params.carousel = findContainer(carousel);
			if (params.carousel) dataParams = getDataAttributes(params.carousel);
		} else if (typeof carousel === 'object') {
			params.carousel = carousel;
			dataParams = getDataAttributes(carousel);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.carousel) {
			VGLog("error", ["Сударь! А где, собственно, карусель?"]);
			return false;
		}

		params = mergeDeepObject(dataParams, params);
		let isInit = true, event = null;

		if ('data-init' in params && params['data-init'] === 'false') {
			isInit = false;
			delete params['data-init'];
		}

		if ('data-event' in params) {
			event = params['data-event'];
			delete params['data-event'];
		}

		if (isInit) {
			for (let key in params) {
				key = key.slice(5);
				if (_this.Set[key] && typeof _this.Set[key] === 'function') {
					let obj = _this.Set[key](key, params);
					option = Object.assign({}, obj, option);
					delete params['data-' + key];
				}
			}

			option = Object.assign({}, _this.Set.options(params), option, arg);

			if (_this.isDebug) {
				console.log('Options carousel: ' + params.carousel.id, option)
			}

			const $swiper = new Swiper('#' + params.carousel.id, option);
			if (event) _this.events($swiper, event);

			_this.checkNavigable($swiper, option)
		}
	},

	events: function (self, events) {
		let _this = this,
			$container = self.$el[0],
			e = events.split(',');

		if (_this.isDebug) {
			console.log('Events "' + self.el.id + '": ', e)
		}

		for (let i = 1; i <= e.length; i++) {
			// Смена слайдов при наведении на пагинацию
			if (e[i - 1] === 'dots-hover') {
				let $bullets = $container.getElementsByClassName('swiper-pagination-bullet');

				for(let i = 0; i < $bullets.length; i++) {
					$bullets[i].onmouseover = function () {
						self.slideTo(i);

						return false;
					}
				}
			}

			// Зависимые слайдеры
			if (e[i - 1] === 'dependence') {
				let depSlidersClasses = $container.dataset.dependence || null;
				if (depSlidersClasses) {
					let $dep_sliders = document.getElementsByClassName(depSlidersClasses);

					if ($dep_sliders.length) {
						self.on('slideChange', function (self) {
							for (let $slider of $dep_sliders) {
								let swiper = document.getElementById($slider.id),
									slider = swiper.swiper;

								slider.slideTo(self.activeIndex)
							}
						});
					}
				}
			}

			// Если есть видео запускаем
			if (e[i - 1] === 'video') {
				self.on('slideChange', function (self) {
					// Останавливаем все запущенные видео
					let $video = $container.querySelectorAll('[data-vg-video] video');
					if ($video.length) {
						for(let $v of $video) {
							$v.pause();
							$v.currentTime = 0;
						}
					}

					// Запускаем на текущем слайде
					if (self.slides[self.activeIndex].getElementsByTagName('video')[0]) {
						self.slides[self.activeIndex].getElementsByTagName('video')[0].currentTime = 0;
						self.slides[self.activeIndex].getElementsByTagName('video')[0].play();
					}
				});
			}
		}
	},

	Set: {
		options: function (opt) {
			let obj = {
				autoHeight: 'data-auto-height' in opt ? opt['data-auto-height'] : false,
				loop: 'data-loop' in opt,
				mousewheel: 'data-mousewheel' in opt,
				simulateTouch: !('data-touch-mouse' in opt && opt['data-touch-mouse'] === 'false'),
				centeredSlides: 'data-centered' in opt,
				freeMode: 'data-free-mode' in opt,
				parallax: 'data-parallax' in opt,
				lazy: true,
				speed: 'data-speed' in opt ? parseInt(opt['data-speed']) : 1000,
				allowTouchMove: (!('data-touch-move' in opt && opt['data-touch-move'] === 'false')),
				watchSlidesProgress: 'data-progress' in opt ? opt['data-progress'] : false,
			}, _breakpoints = VGCarousel.breakpoints;

			let responsive = [],
				default_breakpoints = {
					0: {
						slidesPerView: 1,
						spaceBetween: 12
					},

					640: {
						slidesPerView: 2,
						spaceBetween: 12,
					},

					767: {
						slidesPerView: 2,
						spaceBetween: 24,
					},

					991: {
						slidesPerView: 3,
						spaceBetween: 24,
					}
				};

			for (let key in _breakpoints) {
				responsive.push(key);

				if (!('data-items' in opt)) {
					default_breakpoints[_breakpoints[key]] = {
						slidesPerView: 1,
						spaceBetween: 0,
						slidesPerGroup: 1,
					}
				} else {
					if (key !== 'xs' && key !== 'sm' && key !== 'md' && key !== 'lg') {
						let items = opt['data-items'];

						if (items !== 'auto') {
							items = Number(items);
						}

						default_breakpoints[_breakpoints[key]] = {
							slidesPerView: items,
							spaceBetween: 'data-margin' in opt ? parseInt(opt['data-margin']) : 0,
							slidesPerGroup: 'data-per-group' in opt ? parseInt(opt['data-per-group']) : 1,
						}
					}
				}
			}

			let current_breakpoints = {};
			responsive.forEach(function (v) {
				if ('data-' + v in opt) {
					let key = _breakpoints[v],
						point = opt['data-' + v];

					if (typeof point === 'string') {
						point = JSON.parse(point);
					}

					if ('slidesPerView' in point) {
						default_breakpoints[key].slidesPerView = point['slidesPerView'];
					}

					if ('spaceBetween' in point) {
						default_breakpoints[key].spaceBetween = point['spaceBetween'];
					}

					current_breakpoints[key] = point;
				}
			});

			obj.breakpoints = Object.assign({}, default_breakpoints, current_breakpoints);

			return obj;
		},

		thumbs: function (key, opt) {
			let obj = {};

			if (key === 'thumbs') {
				let el = document.getElementById(opt['data-thumbs']);

				if (el) {
					let params = getDataAttributes(el), option = {};

					if ('data-init' in params) {
						delete params['data-init'];
					}

					for (let key in params) {
						key = key.slice(5);
						if (VGCarousel.Set[key] && typeof VGCarousel.Set[key] === 'function') {
							let obj = VGCarousel.Set[key](key, params);
							option = Object.assign({}, obj, option);
							delete params['data-' + key];
						}
					}

					option = Object.assign({}, VGCarousel.Set.options(params), option);

					if (VGCarousel.isDebug) {
						console.log('Options carousel: ' + el.id, option)
					}

					let thumbs = new Swiper('#' + el.id, option);

					obj = {
						thumbs: {
							swiper: thumbs
						}
					}
				}
			}

			return obj;
		},

		autoplay: function (key, opt) {
			let obj = {};

			if (key === 'autoplay') {
				let delay = 5000;

				if ('data-autoplay-delay' in opt) {
					delay = opt['data-autoplay-delay'];
				}

				obj = {
					autoplay: {
						delay: delay,
						disableOnInteraction: false,
					}
				}
			}

			return obj;
		},

		grid: function (key, opt) {
			let obj = {};

			if (key === 'grid') {
				let row;

				if ('data-grid' in opt) {
					row = opt['data-grid'];
				}

				obj = {
					grid: {
						rows: 2,
						fill: 'column'
					}
				}
			}

			return obj;
		},

		effects: function (key, opt) {
			let obj = {};

			if (key === 'effects') {
				if(opt[`data-${key}`] === 'fade') {
					obj = {
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
					}
				}

				if(opt[`data-${key}`] === 'creative') {
					let optPrev = opt[`data-creative-prev`];
					let optNext = opt[`data-creative-next`];
					// что бы эта дичь работала надо у двух дата-атрибутов написать json такого формата,
					// {"x": 0, "y": 0, "z": -800}
					// Если просто число узкаваем без ковычек,
					// если нужны пиксели или проценты то в кавычках

					optPrev = Object.values(optPrev ? JSON.parse(optPrev) : {});
					optNext = Object.values(optNext ? JSON.parse(optNext) : {});

					obj = {
						effect: 'creative',
						creativeEffect: {
							prev: {
								translate: optPrev.length ? optPrev : [0, 0, -400],
							},
							next: {
								translate: optNext.length ? optNext : ["100%", 0, 0],
							},
						},
					}
				}
			}

			return obj;
		},

		navigation: function (key, opt) {
			let obj = {},
				navigationElements = {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				};

			if (key === 'navigation') {
				if ('data-navigation-prefix' in opt) {
					navigationElements = {
						nextEl: '.swiper-button-next-' + opt['data-navigation-prefix'],
						prevEl: '.swiper-button-prev-' + opt['data-navigation-prefix'],
					}
				}

				obj = {
					navigation: navigationElements
				}
			}

			return obj;
		},

		pagination: function (key, opt) {
			let obj = {};

			if (key === 'pagination') {
				let progressbarOpposite = false,
					dynamicBullets = false,
					type = 'bullets',
					renderBullet = false,
					formatFractionCurrent = (num) => {return num},
					formatFractionTotal = (num) => {return num};

				if ('data-pagination-progress' in opt) {
					progressbarOpposite = true;
				}

				if ('data-pagination-dinamic' in opt) {
					dynamicBullets = true;
				}

				if ('data-pagination-number' in opt) {
					renderBullet = function (index, className) {
						return `<span class="${className} swiper-pagination-number">
									<span class="number">
										${index + 1 <= 9 ? 0 : ''}${index + 1}
									</span>
								</span>`;
					};
				}

				if ('data-pagination-fraction' in opt) {
					type = 'fraction';

					if(opt['data-pagination-fraction-zero']) {
						function addZero(num){
							return (num > 9) ? num : '0' + num;
						}

						formatFractionCurrent = function(num) {
							return addZero(num);
						};

						formatFractionTotal = function(num) {
							return addZero(num);
						}
					}
				}

				obj = {
					pagination: {
						el: '.swiper-pagination',
						type: type,
						clickable: true,
						progressbarOpposite: progressbarOpposite,
						dynamicBullets: dynamicBullets,
						formatFractionCurrent,
						formatFractionTotal,
						renderBullet
					},
				};
			}

			return obj;
		},
	},

	checkNavigable: function (swiper, option) {
		let $container = swiper.el,
			count_slides = $container.querySelectorAll('.swiper-slide').length,
			elements = ['.swiper-pagination', '.swiper-button-next', '.swiper-button-prev'];

		showHideElements($container, elements);

		if (window.innerWidth < 640 && count_slides <= option.breakpoints[0].slidesPerView) {
			showHideElements($container, elements, false);

			return false;
		} else if ((window.innerWidth >= 640 && window.innerWidth < 767) && (count_slides <= option.breakpoints[640].slidesPerView)) {
			showHideElements($container, elements, false);

			return false;
		} else if ((window.innerWidth >= 767 && window.innerWidth < 991) && (count_slides <= option.breakpoints[640].slidesPerView)) {
			showHideElements($container, elements, false);

			return false;
		} else if ((window.innerWidth >= 991 && window.innerWidth < 1199) && (count_slides <= option.breakpoints[991].slidesPerView)) {
			showHideElements($container, elements, false);

			return false;
		} else if ((window.innerWidth >= 1199 && window.innerWidth < 1399) && (count_slides <= option.breakpoints[1199].slidesPerView)) {
			showHideElements($container, elements, false);

			return false;
		} else if ((window.innerWidth >= 1399 && window.innerWidth <= 1599) && (count_slides <= option.breakpoints[1399].slidesPerView)) {
			showHideElements($container, elements, false);

			return false;
		} else if (window.innerWidth > 1599 && (count_slides <=  option.breakpoints[1599].slidesPerView)) {
			showHideElements($container, elements, false);

			return false;
		}

		function showHideElements ($container, elements = [], show = true) {
			if (elements.length) {
				if (show) {
					for (let i = 0; i < elements.length; i++) {
						let $el = $container.querySelector(elements[i]);
						if ($el) {
							$container.querySelector(elements[i]).style.display = 'block';
						}
					}
				} else {
					for (let i = 0; i < elements.length; i++) {
						let $el = $container.querySelector(elements[i]);
						if ($el) {
							$container.querySelector(elements[i]).style.display = 'none';
						}
					}
				}
			}
		}

		return true;
	}
};

function onReady() {
	let $carousels = document.querySelectorAll('.swiper');
	if ($carousels.length) {
		for (let carousel of $carousels) {
			VGCarousel.init(carousel);
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGCarousel;
